import { Button, Tooltip } from "@material-ui/core";
import "./BookScreenButton.css";

interface bookScreenButtonInterface {
  text: string;
  tooltip: string;
  onPressed: () => void;
  disabled?: boolean;
}

const BookScreenButton = ({ tooltip, disabled = false, onPressed, text }: bookScreenButtonInterface) => (
  <div className="root">
    <Tooltip title={tooltip}>
      <Button disabled={disabled} className={`button ${disabled ? "disabledButton" : ""}`} onClick={onPressed}>
        <div className="buttonText">{text}</div>
      </Button>
    </Tooltip>
  </div>
);

export default BookScreenButton;
